/**
 * NumberFieldSettings содержит параметры конфигурации для числового поля
 */
export class NumberFieldSettings {
  /**
   * IsNeedDisplayChangeButtons содержит флаг, позволяющий включить отображение
   * кнопок изменения значения (+ и -).
   */
  public IsNeedDisplayChangeButtons: boolean = false;

  /**
   * FieldTextDirection содержит направление выравнивания текста внутри поля.
   * Доступные варианты для выбора:
   *  - left - По левому краю
   *  - right - По правому краю
   *  - center - По центру
   */
  public FieldTextDirection: string = "left";

  /**
   * LimitMinValue ограничивает минимальное значение для поля.
   * Если значение не задано, то ограничения нет.
   */
  public LimitMinValue?: number = undefined;

  /**
   * LimitMaxValue ограничивает максимальное значение для поля.
   * Если значение не задано, то ограничения нет.
   */
  public LimitMaxValue?: number = undefined;

  /**
   * EnableDecimalValues позволяет включить в поле задание значения
   * с плавающей точностью.
   */
  public EnableDecimalValues: boolean = true;

  /**
   * IsCurrencyCourseField содержит флаг, позволяющий использовать
   * поле как для ввода курса валюты.
   */
  public IsCurrencyCourseField: boolean = false;

  /**
   * Поле, которое будет содержать валюту для поля курса. Должно быть валютой.
   */
  public CurrencyField: string = ""

  /**
   * IsCourseRequired содержит флаг, указывающий на обязательность поля
   * численного поля курса. Поле будет присутствовать всегда, даже если
   * соотвествующее поле валюты не используется или дублируется.
   */
  public IsCourseRequired: boolean = false;

  /**
   * IsAltaCountry содержит флаг, позволяющий включить отображение
   * стран из апи Alta для таможенных платежей. 
   */
  public IsAltaCountry: boolean = false;

  /**
   * Заглушка для запрета прямого создания объектов данного типа
   * @private
   */
  private constructor() {
  }

  /**
   * RestoreSettings выполняет восстановление данных объекта настроек
   * Функция выполняет нормализацию значений настроек.
   * Функция дополняет недостающие настройки значениями по умолчанию.
   *
   * @param data
   */
  public static RestoreSettings(data: any): NumberFieldSettings {
    let result = new NumberFieldSettings();

    if (typeof data === "string") {
      data = JSON.parse(data)
    }

    if (typeof data !== "object") {
      return result;
    }

    Object.keys(result).map((key: keyof NumberFieldSettings) => {
      // @ts-ignore
      result[key] = NumberFieldSettings.GetCorrectFieldValue(key, data[key])
    })

    return result;
  }

  /**
   * GetCorrectFieldValue выполняет восстановление данных поля из переданного значения настроек.
   * Данный метод так же проводит валидацию значения каждой из настроек поля. Метод возвращает
   * значение по умолчанию, если значение передано не корректно.
   */
  public static GetCorrectFieldValue<T extends keyof NumberFieldSettings>(field: T, data: any): any {
    let defaults = new NumberFieldSettings()

    if (data === undefined) {
      return defaults[field]
    }

    switch (field) {
      case "FieldTextDirection":
        return ["left", "right", "center"].indexOf(data) !== -1 ? data : defaults[field]
      case "IsNeedDisplayChangeButtons":
      case "EnableDecimalValues":
	  case "IsCurrencyCourseField":
	  case "IsCourseRequired":
	  case "IsAltaCountry":
        return !!data
      case "LimitMinValue":
      case "LimitMaxValue":
        return typeof data === "number" ? data : defaults[field]
	  case "CurrencyField":
		return typeof data === "string" ? data : defaults[field]
    }

    return defaults[field];
  }
}